import axios, { AxiosResponse } from 'axios';
import { getAccessToken, handleUnauthorized } from '../auth';
import { getUserFacingError } from './userFacingError';

async function postApi(url: string, payload: any): Promise<any> {
  try {
    const response: AxiosResponse = await axios.post(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${getAccessToken()}`
      },
    });
    return response;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        const isPublicAuth =
          url.includes('/login') ||
          url.includes('/forgot_password') ||
          url.includes('/reset_password') ||
          url.includes('/registration');
        if (!isPublicAuth) {
          handleUnauthorized();
        }
      }
      throw new Error(getUserFacingError(error));
    }
    throw new Error(getUserFacingError(error));
  }
}

export default postApi;
